import type { RunPlan } from '@1qa/shared';
import type { TestGroup } from './types';

/** How a group runs, in a few words. */
export function groupModeLabel(g: Pick<TestGroup, 'mode' | 'maxParallel'>): string {
  return g.mode === 'PARALLEL' ? `${g.maxParallel} at a time` : 'One after another';
}

/** One line describing how a run executed its tests, or null for plain runs (no group, defaults). */
export function runPlanLabel(plan: RunPlan | null | undefined): string | null {
  if (!plan) return null;
  const parts = [plan.groupName ? `Group “${plan.groupName}”` : null, plan.mode === 'PARALLEL' ? `up to ${plan.maxParallel} tests at a time` : 'one test after another'];
  if (plan.stopOnFailure) parts.push('stops at the first failure');
  return parts.filter(Boolean).join(' · ');
}
